import React, { Component } from 'react'
import { Alert } from 'loyal-react'

import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import MobileRechargeScheduleItem from './MobileRechargeScheduleItem'
import { AboutMobileRechargeSchedule } from './AboutMobileRechargeSchedule'

class ConfirmationMobileRechargeSchedule extends Component {
  state = {
    supplierName: ''
  }

  componentDidMount () {
    if (this.props.scheduleRecharge.vendorId) {
      const name =
        this.props.stores.filter(
          ele => ele.supplierId === this.props.scheduleRecharge.vendorId
        ).length > 0
          ? this.props.stores.filter(
            ele => ele.supplierId === this.props.scheduleRecharge.vendorId
          )[0].name
          : ''

      this.setState({ supplierName: name })
    }

    if (this.props.scheduleId) {
      this.props.getScheduleRecharge(this.props.scheduleId)
    }
  }

  render () {
    if (!this.props.scheduleRecharge || this.props.scheduleRecharge.notFount) {
      this.props.redirectNotFoundPage()
    }

    let firstServiceItem =
      this.props.scheduleRecharge.serviceItem &&
      this.props.scheduleRecharge.serviceItem.length > 0 &&
      this.props.scheduleRecharge.serviceItem[0]

    return (
      <div className='container-cart container py-5 '>

        <div className='row mb-4'>
          <Alert
            isError={false}
            title='Parabéns! Seu resgate foi concluído com sucesso.'
            description='Veja abaixo o resumo do seu pedido.'
          />
        </div>
        <div className='row'>
          <div className='cart-side col-8 pl-0 pr-2'>
            <div className='border-ui-3 radius bg-white'>
              <div className='col-12 py-3 px-3 mx-0  border-color-ui-3 border-bottom'>
                <h3 className='color-title txt-font-body txt-uppercase txt-body'>
                  Resumo do pedido
                </h3>
              </div>
              <div className='cart-products col-12 mx-0'>
                <MobileRechargeScheduleItem
                  name={`Recarga Pré-pago ${
                    this.props.scheduleRecharge.operator
                  } ${this.props.scheduleRecharge.ddd} - R$${firstServiceItem &&
                    firstServiceItem.value}`}
                  vendorName={this.state.supplierName}
                  areaCode={this.props.scheduleRecharge.ddd}
                  phoneNumber={this.props.scheduleRecharge.phone}
                  vendorId={this.props.scheduleRecharge.vendorId}
                  initialScheduleDate={
                    this.props.scheduleRecharge.firstSchedule
                  }
                  finalScheduleDate={this.props.scheduleRecharge.lastSchedule}
                />
              </div>
            </div>
          </div>
          <AboutMobileRechargeSchedule
            dateCreatedScheduling={
              this.props.scheduleRecharge.dateCreatedScheduling
            }
            operator={this.props.scheduleRecharge.operator}
            phoneNumber={this.props.scheduleRecharge.phone}
            creditValue={firstServiceItem && firstServiceItem.value}
            pointValue={firstServiceItem && firstServiceItem.pointValue}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ stores }) => ({
  stores: stores.services
})

ConfirmationMobileRechargeSchedule.propTypes = {
  scheduleRecharge: PropTypes.object,
  redirectNotFoundPage: PropTypes.func,
  scheduleId: PropTypes.string,
  getScheduleRecharge: PropTypes.func,
  stores: PropTypes.object
}

export default connect(mapStateToProps)(ConfirmationMobileRechargeSchedule)



// WEBPACK FOOTER //
// ./src/features/ConfirmationMobileRechargeSchedule/ConfirmationMobileRechargeSchedule.js